import React from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
// import { purple } from '@mui/material/colors';
export default function RadioButtonsGroup(props) {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        name={props.name}
        value={props.value}
        onChange={props.handleChange}
        style={{
          color: props.color,
          backgroundColor: props.backgroundColor,
          fontWeight: props.fontWeight,
          textAlign: props.textAlign,
        }}

        defaultValue={props.defaultValue}
      >
        <div style={{}}>
          {props.listItems.map((row) => (
            <FormControlLabel
              key={row.id}
              value={row.id}
              control={
                <Radio
                  {...props.register}
                  disabled={props.disabled ? true : row.id == "routeNumber" ? true : false}
                // sx={{
                //   color: purple[800],
                //   '&.Mui-checked': {
                //     color: purple[600],
                //   },
                // }} //for changing color of radio
                />
              }
              label={row.label} // Label beside the radio button
            />
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  );
}
